module.exports = __webpack_public_path__ + "img/logo-nao-con-lineas.0c494ef3.svg";